import type React from 'react';

import { UnderReviewError } from 'src/shared/error';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { Layout } from '../layout';

export const DetailsStateWrapper: React.FC = () => {
	const {
		data: { petition },
	} = usePetitionDetailsPageData();
	const {
		data: { canEdit },
	} = usePetitionDetailsPageUserData();

	const underReview = petition.status === 'UNDER_REVIEW';
	if (underReview && !canEdit) {
		throw new UnderReviewError();
	}

	return <Layout />;
};
